export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/black_background.2199683.svg";